// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import * as uiHelpers from "../UserUIHelpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../_metronic/_partials/controls";
import { useUserUIContext } from "../UserUIContext";

export function UserTable({
  isLoading,
  userListTotalCount,
  currentPage,
  setCurrentPage,
  userList,
}) {
  // User UI Context
  const userUIContext = useUserUIContext();
  const userUIProps = useMemo(() => {
    return {
      ids: userUIContext.ids,
      setIds: userUIContext.setIds,
      queryParams: userUIContext.queryParams,
      setQueryParams: userUIContext.setQueryParams,
      openReceiptDialog: userUIContext.openReceiptDialog,
      openEditStatusDialog: userUIContext.openEditStatusDialog,
    };
  }, [userUIContext]);

  // Table columns
  const columns = [
    // {
    //   dataField: "id",
    //   text: "ID",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   style: {
    //     minWidth: "60px",
    //   },
    // },
    {
      dataField: "account_number",
      text: "ACCOUNT NUMBER",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
      formatter: columnFormatters.AccountNumberFormatter,
    },
    {
      dataField: "firstname",
      text: "FIRST NAME",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
      formatter: columnFormatters.FirstNameFormatter,
    },
    {
      dataField: "lastname",
      text: "LAST NAME",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
      formatter: columnFormatters.LastNameFormatter,
    },
    {
      dataField: "cellnumber",
      text: "MOBILE NUMBER",
      style: {
        minWidth: "140px",
      },
    },
    {
      dataField: "email",
      text: "EMAIL",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "110px",
        maxWidth: "150px",
      },
    },
    {
      dataField: "business_name",
      text: "BUSINESS NAME",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.BusinessNameFormatter,
      style: {
        minWidth: "110px",
      },
    },
    {
      dataField: "last_transaction_date",
      text: "LAST TRANSACTION DATE",
      formatter: columnFormatters.LastTransactionDateFormatter,
      style: {
        minWidth: "110px",
      },
    },
    {
      dataField: "createdAt",
      text: "JOINING DATE",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.JoiningDateFormatter,
      style: {
        minWidth: "110px",
      },
    },
    // {
    //   dataField: "usermetum.available_funds",
    //   text: "CURRENT BALANCE",
    //   formatter: columnFormatters.AmountColumnFormatter,
    //   style: {
    //     minWidth: "110px",
    //   },
    // },
    {
      dataField: "countryId",
      text: "COUNTRY",
      // sort: true,
      // sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
      formatter: columnFormatters.CountryTypeFormatter,
    },
    {
      dataField: "status",
      text: "STATUS",
      style: {
        minWidth: "110px",
      },
      formatter: columnFormatters.StatusTypeFormatter,
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openReceiptDialog: userUIProps.openReceiptDialog,
        openEditStatusDialog: userUIProps.openEditStatusDialog,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: userListTotalCount ? userListTotalCount : 0,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: userUIProps.queryParams.pageSize,
    page: currentPage,
    onPageChange: (page) => {
      if (page === 0) return;
      setCurrentPage(page);
    },
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination isLoading={isLoading} paginationProps={paginationProps}>
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-head-bg table-borderless table-vertical-center user-table"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={userList === null ? [] : userList}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  userUIProps.setQueryParams
                )}
                {...paginationTableProps}
              ></BootstrapTable>
              {/* <PleaseWaitMessage isLoading={isLoading} /> */}
              <NoRecordsFoundMessage entities={userList} errorMessage={"No users found!"}/>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
